/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Input } from '@angular/core';
import { SearchJobResult } from '../../../generated/graphql.generated';

@Component({
  selector: 'app-search-job-result',
  templateUrl: './search-job-result.component.html',
  styleUrls: ['./search-job-result.component.scss'],
})
export class SearchJobResultComponent {
  @Input() result: SearchJobResult | null = null;
}